import { MinusOutlined, PlusOutlined } from '@ant-design/icons';
import { Collapse, Typography } from 'antd';
import React, { useState } from 'react';
import * as S from './DealRoomSection.styles';
import { PanelItem } from './ThirdPartyInsurance';

const { Title, Text } = Typography;
export const { Panel } = Collapse;

const InsuranceCover: React.FC = () => {
  return (
    <>
      <S.ContentTextWrapper>
        <Text className="sub-text">{`הביטוח מכסה נזקים לתכולת הבית המשותף במקרים הבאים: רעידת אדמה (אם נרכש כיסוי רעידת אדמה בפוליסה), שריפה, התפוצצות גז, פריצה, גניבה, נזקי סערה או סופה, נזק בזדון והצפה ממקור מים חיצוני.`}</Text>
      </S.ContentTextWrapper>

      <S.ContentTextWrapper className="mt-24">
        <Title level={2} className="main-title regular">
          {`מקרים ביטוחיים לדוגמה:`}
        </Title>
        <S.ListWrapper>
          <S.ListItem>{`במסגרת ביקורת כיסוי אש שנתית התברר שכנופיית גנבים פרצה וגנבה מהבניין את כל ציוד כיבוי אש שנמצא בכל קומה וקומה, נזק כולל של כ-15,000 ₪.`}</S.ListItem>
          <S.ListItem>{`אדם זר גרם נזק בזדון לשרת הקלטות של הבניין ולמצלמה, ככול הנראה במטרה לטשטש צילום של ארוע שקרה בשטח רכוש משותף.`}</S.ListItem>
        </S.ListWrapper>
      </S.ContentTextWrapper>
    </>
  );
};

const InsuranceNotCover: React.FC = () => {
  return (
    <>
      <S.ContentTextWrapper>
        <Text className="sub-text">{`כל נזק שלא מצוין מעלה – אינו מכוסה.`}</Text>
      </S.ContentTextWrapper>

      <S.ContentTextWrapper className="mt-24">
        <Title level={2} className="main-title regular">
          {`מקרים ביטוחיים לדוגמה:`}
        </Title>
        <Text className="sub-text">{`תיקון ציוד כיבוי אש שנמצא לקוי, בלאי של מערכת מצלמות, תיקון טלוויזיה בחדר דיירים וכו'.`}</Text>
      </S.ContentTextWrapper>
    </>
  );
};

const FAQs: React.FC = () => {
  return (
    <>
      <S.ContentTextWrapper>
        <S.ListWrapper className="number">
          <S.ListItem>
            <S.ListTitle>
              {`הבניין שלנו בניין חדש לחלוטין שרק נמסר מהקבלן, כל הציוד חדש וחלקו אף`}
              <br />
              {`באחריות, האם אנחנו צריכים כיסוי תכולה משותפת?`}
            </S.ListTitle>
            <S.ListContent>{`כן, הביטוח אינו מכסה תקלות/בלאי בתכולה המשותפת אלא אירועים ביטוחיים כמו שריפה, פריצה, גניבה וכו' ולכן בין אם הציוד חדש או לא אין זה רלוונטי, ומומלץ לרכוש ביטוח זה.`}</S.ListContent>
          </S.ListItem>
          <S.ListItem>
            <S.ListTitle>{`יש לנו חדר כושר משותף בבניין, האם ציוד הכושר נכלל?`}</S.ListTitle>
            <S.ListContent>{`אם רכשתם במסגרת הביטוח גם כיסוי לתכולה משותפת אכן גם תכולת חדר הכושר תהיה מבוטחת. כמובן שמומלץ לבצע בדיקה מה שווי המכשירים ולוודא כי גובה הכיסוי הביטוחי שנרכש מספיק.`}</S.ListContent>
          </S.ListItem>
          <S.ListItem>
            <S.ListTitle>
              {`יש לנו בבניין מצלמות באזורים שונים של הרכוש המשותף, מספר מצלמות הפסיקו`}
              <br />
              {`לעבוד, האם ניתן להפעיל את הביטוח?`}
            </S.ListTitle>
            <S.ListContent>{`אם המצלמות הפסיקו לעבוד בגלל בלאי/תקלה, לא ניתן להפעיל את הביטוח. אם לצורך העניין הייתה חס וחלילה פורצת שריפה וחלק מהמצלמות נשרפו אז כמובן ניתן להפעיל את הביטוח, שכן אירוע כמו שריפה הוא אירוע ביטוחי.`}</S.ListContent>
          </S.ListItem>
          <S.ListItem>
            <S.ListTitle>
              {`יש לנו חדר אופניים בבניין ולאחד הדיירים גנבו משם את האופניים שלו, האם`}
              <br />
              {`הביטוח יכסה?`}
            </S.ListTitle>
            <S.ListContent>{`לא, כיסוי תכולה בפוליסה של הרכוש המשותף מיועד לתכולה משותפת, אופניים פרטיים של דייר זה לא רכוש משותף ולכן לא ניתן לבטח אותם במסגרת ביטוח התכולה של הבית המשותף. הדייר יכול לבטח את האופניים במסגרת ביטוח הדירה שלו כולל הרחבה לכיסוי גניבה מחוץ לשטח הדירה.`}</S.ListContent>
          </S.ListItem>
        </S.ListWrapper>
      </S.ContentTextWrapper>
    </>
  );
};

const panelItems: PanelItem[] = [
  {
    key: '1',
    title: 'מה הביטוח מכסה?',
    content: <InsuranceCover />,
  },
  {
    key: '2',
    title: `מה הביטוח לא מכסה?`,
    content: <InsuranceNotCover />,
  },
  {
    key: '3',
    title: `שאלות ותשובות נפוצות`,
    content: <FAQs />,
  },
];
export const SharedBuildingContent: React.FC = () => {
  const [activeKey, setActiveKey] = useState<string | string[]>();

  return (
    <S.Wrapper>
      <S.Header>
        <Title level={2} className="main-title">
          {`ביטוח תכולה לבית המשותף`}
        </Title>
        <Title level={2} className="main-title">{`למה צריך ביטוח תכולה לבית המשותף?`}</Title>
        <Text className="sub-text">{`פרק תכולת בית משותף הינו פרק נלווה לפרק מבנה וברירת המחדל היא לרכוש את הכיסוי ביחד עם ביטוח מבנה. הפרק מכסה את הרכוש המשותף שמוגדר כתכולה ואינו צמוד מבנה וכולל: תכולת חדר דיירים, פחי אשפה, מטפי כיבוי אש, מצלמות, שרת/מחשב, מצלמות, ציוד חדר כושר, תכולת לובי הבניין וכו'. סכומי הביטוח בפרק תכולה מתחילים ב-25,000 ₪ ועד 500,000 ₪ (תלוי בגודל הבניין ובאופי הרכוש המשותף).`}</Text>
      </S.Header>
      <S.IconCollapseWrapper>
        <S.IconCollapse accordion className="custom-collapse" activeKey={activeKey} onChange={setActiveKey}>
          {panelItems.map((item) => (
            <Panel
              key={item.key}
              showArrow={false}
              header={
                <S.PanelHeader>
                  <S.IconWrapper>
                    {activeKey === item.key ? (
                      <MinusOutlined className="plus-icon" />
                    ) : (
                      <PlusOutlined className="plus-icon" />
                    )}
                  </S.IconWrapper>
                  <Text strong className="header-text">
                    {item.title}
                  </Text>
                </S.PanelHeader>
              }
            >
              {item.content}
            </Panel>
          ))}
        </S.IconCollapse>
      </S.IconCollapseWrapper>
    </S.Wrapper>
  );
};
